<template>
  <div id="app">
    <MainTopHeader v-if="$route.meta.showHeader !== false" />
    <router-view></router-view>
    <MainBottomFooter v-if="$route.meta.showFooter !== false" />
    <KnowledgeChatFab v-if="showChatFab" />
  </div>
</template>


<script>
import MainTopHeader from '@/components/cards/MainTopHeader.vue'
import MainBottomFooter from './components/cards/MainBottomFooter.vue';
import KnowledgeChatFab from '@/components/cards/knowledge-chat/KnowledgeChatFab.vue';
import darkModeService from '@/services/darkModeService';
import { isAuthenticated } from '@/services/authService';

export default {
  name: 'App',
  components: {
    MainTopHeader,
    MainBottomFooter,
    KnowledgeChatFab,
  },
  computed: {
    showChatFab() {
      return isAuthenticated()
        && this.$route.name !== 'LoginPage'
        && this.$route.name !== 'KnowledgeAssistantPage';
    },
  },
  mounted() {
    // Initialize dark mode on app mount
    darkModeService.initialize();
  }
}
</script>
<style scoped>


</style>
